import type { KoruAppConfig } from '@/types'
import powerSellerIcon from '@/assets/brand/power-seller-icon.webp'

export const DEFAULT_APP_NAME = 'Power Seller'
export const DEFAULT_ACCENT = '#6d28d9'
/** Ícono de Power Seller (el producto): fallback cuando el retailer no cargó su propio logo. */
export const DEFAULT_LOGO_URL = powerSellerIcon

/** Contraste legible (blanco/negro) sobre un color hex, por luminancia relativa. */
export function readableTextColor(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return '#ffffff'
  const int = parseInt(m[1], 16)
  const r = (int >> 16) & 255
  const g = (int >> 8) & 255
  const b = int & 255
  // Luminancia percibida (sRGB aproximado).
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#0f172a' : '#ffffff'
}

/** Aplica la marca (white label §5.2) a las CSS vars y al título del browser. */
export function applyBrand(config: Partial<KoruAppConfig> | null | undefined): void {
  const root = document.documentElement
  const accent = config?.primaryColor?.trim() || DEFAULT_ACCENT

  root.style.setProperty('--color-accent', accent)
  root.style.setProperty('--color-accent-contrast', readableTextColor(accent))
  root.style.setProperty('--color-accent-soft', `color-mix(in srgb, ${accent} 10%, white)`)

  const appName = config?.appName?.trim() || DEFAULT_APP_NAME
  document.title = appName
}
